import React from "react";
import aiImage from "../ai.png";
import { heroStats, profile } from "../data/portfolio";

const AboutWindow = ({ navigate }) => {
  const year = new Date().getFullYear();

  return (
    <div className="flex h-full flex-col bg-[#c0c0c0] font-ui text-win-text">
      <div className="win-sunken-thin m-2 flex items-center gap-2 px-2 py-1 text-xs">
        <span aria-hidden="true">📁</span>
        C:\JAKOB\ABOUT.TXT
      </div>

      <div className="flex-1 overflow-auto px-4 pb-4">
        <div className="win-raised inline-block px-3 py-1 text-xs font-bold uppercase tracking-wide text-win-navy">
          {profile.role}
        </div>

        <h1 className="mt-4 text-3xl font-black leading-tight sm:text-4xl">{profile.headline}</h1>

        <p className="mt-4 max-w-2xl text-sm leading-6 sm:text-base">{profile.intro}</p>

        <div className="mt-5 flex flex-col gap-5 lg:flex-row lg:items-start">
          <div className="win-sunken-thin w-full max-w-[280px] shrink-0 p-2">
            <div className="relative overflow-hidden border border-[#808080]">
              <img src={aiImage} alt={profile.imageAlt} className="h-56 w-full object-cover sm:h-64" />
            </div>
            <p className="mt-2 text-center text-[11px] italic text-[#404040]">{profile.availability}</p>
          </div>

          <div className="flex flex-1 flex-col gap-4">
            <div className="grid grid-cols-3 gap-2">
              {heroStats.map(({ value, label }) => (
                <div key={label} className="win-sunken-thin p-3 text-center">
                  <p className="text-xl font-black text-win-navy">{value}</p>
                  <p className="mt-1 text-[10px] font-bold uppercase leading-tight text-[#404040]">{label}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3">
              <button type="button" onClick={() => navigate("projects")} className="win-btn win-focus-dotted px-4 py-2 text-sm font-bold">
                View projects ▸
              </button>
              <button type="button" onClick={() => navigate("contact")} className="win-btn win-focus-dotted px-4 py-2 text-sm font-bold">
                ✉ Start a conversation
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="win-sunken-thin mx-2 mb-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 px-2 py-1 text-[11px] text-[#404040]">
        <span>© {year} {profile.name}. Built with React.</span>
        <span>Portfolio / Full-stack development / OsloMet</span>
      </div>
    </div>
  );
};

export default AboutWindow;
